import React from 'react';

const InfanziaIcon = props => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.06228 20H8.93772C8.17867 20 7.79914 20 7.46911 19.8506C7.13909 19.7013 6.902 19.4222 6.42782 18.8641L4.04634 16.0611C3.58132 15.5138 3.34881 15.2402 3.22802 14.9159C3.10722 14.5917 3.10722 14.2412 3.10722 13.5403V8.27709C3.10722 7.59221 3.10722 7.24977 2.96019 6.94876C2.81316 6.64776 2.53703 6.4249 1.98478 5.97919L1.77744 5.81185C0.595464 4.85789 0.00447491 4.38092 2.80553e-05 3.69048C-0.00441873 3.00004 0.519756 2.5665 1.56811 1.6994C1.7268 1.56815 1.88401 1.44537 2.03581 1.33647C2.60851 0.92561 3.43826 0.47259 4.02213 0.170303C4.45452 -0.0535614 4.97468 -0.0542198 5.41603 0.153567L5.68001 0.277846C5.74931 0.310471 5.80836 0.35956 5.85134 0.42026C7.34922 2.53585 10.6508 2.53585 12.1487 0.42026C12.1916 0.35956 12.2507 0.310471 12.32 0.277846L12.584 0.153567C13.0253 -0.0542198 13.5455 -0.0535612 13.9779 0.170303C14.5617 0.47259 15.3915 0.92561 15.9642 1.33647C16.116 1.44537 16.2732 1.56815 16.4319 1.69941C17.4802 2.5665 18.0044 3.00004 18 3.69048C17.9955 4.38092 17.4045 4.85789 16.2226 5.81185L16.0152 5.97919C15.463 6.4249 15.1868 6.64776 15.0398 6.94876C14.8928 7.24977 14.8928 7.59221 14.8928 8.27709V13.5403C14.8928 14.2412 14.8928 14.5917 14.772 14.9159C14.6512 15.2402 14.4187 15.5138 13.9537 16.0611L11.5722 18.8641C11.098 19.4222 10.8609 19.7013 10.5309 19.8506C10.2009 20 9.82133 20 9.06228 20Z"
        fill={fill}
      />
    </svg>
  );
};

export default InfanziaIcon;
